"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _RequestBuilder_instances, _RequestBuilder_builders, _RequestBuilder_options, _RequestBuilder_log, _RequestBuilder_groupByRelay, _RequestFilterBuilder_filter, _RequestFilterBuilder_relays;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestFilterBuilder = exports.RequestBuilder = exports.RequestStrategy = void 0;
const debug_1 = __importDefault(require("debug"));
const uuid_1 = require("uuid");
const shared_1 = require("@snort/shared");
const request_splitter_1 = require("./request-splitter");
const gossip_model_1 = require("./gossip-model");
const request_merger_1 = require("./request-merger");
const request_expander_1 = require("./request-expander");
/**
 * Which strategy is used when building REQ filters
 */
var RequestStrategy;
(function (RequestStrategy) {
    /**
     * Use the users default relays to fetch events,
     * this is the fallback option when there is no better way to query a given filter set
     */
    RequestStrategy[RequestStrategy["DefaultRelays"] = 1] = "DefaultRelays";
    /**
     * Using a cached copy of the authors relay lists NIP-65, split a given set of request filters by pubkey
     */
    RequestStrategy[RequestStrategy["AuthorsRelays"] = 2] = "AuthorsRelays";
    /**
     * Use pre-determined relays for query
     */
    RequestStrategy[RequestStrategy["ExplicitRelays"] = 3] = "ExplicitRelays";
})(RequestStrategy = exports.RequestStrategy || (exports.RequestStrategy = {}));
/**
 * Nostr REQ builder
 */
class RequestBuilder {
    constructor(id) {
        _RequestBuilder_instances.add(this);
        _RequestBuilder_builders.set(this, void 0);
        _RequestBuilder_options.set(this, void 0);
        _RequestBuilder_log.set(this, (0, debug_1.default)("RequestBuilder"));
        this.instance = (0, uuid_1.v4)();
        this.id = id;
        __classPrivateFieldSet(this, _RequestBuilder_builders, [], "f");
    }
    get numFilters() {
        return __classPrivateFieldGet(this, _RequestBuilder_builders, "f").length;
    }
    get options() {
        return __classPrivateFieldGet(this, _RequestBuilder_options, "f");
    }
    /**
     * Add another request builders filters to this one
     */
    add(other) {
        __classPrivateFieldGet(this, _RequestBuilder_builders, "f").push(...__classPrivateFieldGet(other, _RequestBuilder_builders, "f"));
    }
    withFilter() {
        const ret = new RequestFilterBuilder();
        __classPrivateFieldGet(this, _RequestBuilder_builders, "f").push(ret);
        return ret;
    }
    withOptions(opt) {
        __classPrivateFieldSet(this, _RequestBuilder_options, {
            ...__classPrivateFieldGet(this, _RequestBuilder_options, "f"),
            ...opt,
        }, "f");
        return this;
    }
    buildRaw() {
        return __classPrivateFieldGet(this, _RequestBuilder_builders, "f").map(f => f.filter);
    }
    build(relays) {
        const expanded = __classPrivateFieldGet(this, _RequestBuilder_builders, "f").flatMap(a => a.build(relays, this.id));
        return __classPrivateFieldGet(this, _RequestBuilder_instances, "m", _RequestBuilder_groupByRelay).call(this, expanded);
    }
    /**
     * Detects a change in request from a previous set of filters
     */
    buildDiff(relays, prev) {
        const start = (0, shared_1.unixNowMs)();
        const next = __classPrivateFieldGet(this, _RequestBuilder_builders, "f").flatMap(f => (0, request_expander_1.expandFilter)(f.filter));
        const diff = (0, request_splitter_1.diffFilters)(prev, next);
        const ts = (0, shared_1.unixNowMs)() - start;
        __classPrivateFieldGet(this, _RequestBuilder_log, "f").call(this, "buildDiff %s %d ms", this.id, ts);
        if (diff.changed) {
            return (0, gossip_model_1.splitFlatByWriteRelays)(relays, diff.added).map(a => {
                return {
                    strategy: RequestStrategy.AuthorsRelays,
                    filters: (0, request_merger_1.flatMerge)(a.filters),
                    relay: a.relay,
                };
            });
        }
        else {
            __classPrivateFieldGet(this, _RequestBuilder_log, "f").call(this, `Wasted ${ts} ms detecting no changes!`);
        }
        return [];
    }
}
exports.RequestBuilder = RequestBuilder;
_RequestBuilder_builders = new WeakMap(), _RequestBuilder_options = new WeakMap(), _RequestBuilder_log = new WeakMap(), _RequestBuilder_instances = new WeakSet(), _RequestBuilder_groupByRelay = function _RequestBuilder_groupByRelay(expanded) {
    const relayMerged = expanded.reduce((acc, v) => {
        const existing = acc.get(v.relay);
        if (existing) {
            existing.push(v);
        }
        else {
            acc.set(v.relay, [v]);
        }
        return acc;
    }, new Map());
    const filtersSquashed = [...relayMerged.values()].map(a => {
        return {
            filters: (0, request_merger_1.mergeSimilar)(a.flatMap(b => b.filters)),
            relay: a[0].relay,
            strategy: a[0].strategy,
        };
    });
    return filtersSquashed;
};
/**
 * Builder class for a single request filter
 */
class RequestFilterBuilder {
    constructor() {
        _RequestFilterBuilder_filter.set(this, {});
        _RequestFilterBuilder_relays.set(this, new Set());
    }
    get filter() {
        return { ...__classPrivateFieldGet(this, _RequestFilterBuilder_filter, "f") };
    }
    /**
     * Use a specific relay for this request filter
     */
    relay(u) {
        const uClean = (0, shared_1.sanitizeRelayUrl)(u);
        if (uClean) {
            __classPrivateFieldGet(this, _RequestFilterBuilder_relays, "f").add(uClean);
        }
        return this;
    }
    ids(ids) {
        __classPrivateFieldGet(this, _RequestFilterBuilder_filter, "f").ids = (0, shared_1.appendDedupe)(__classPrivateFieldGet(this, _RequestFilterBuilder_filter, "f").ids, ids);
        return this;
    }
    authors(authors) {
        if (!authors)
            return this;
        __classPrivateFieldGet(this, _RequestFilterBuilder_filter, "f").authors = (0, shared_1.appendDedupe)(__classPrivateFieldGet(this, _RequestFilterBuilder_filter, "f").authors, authors);
        return this;
    }
    kinds(kinds) {
        if (!kinds)
            return this;
        __classPrivateFieldGet(this, _RequestFilterBuilder_filter, "f").kinds = (0, shared_1.appendDedupe)(__classPrivateFieldGet(this, _RequestFilterBuilder_filter, "f").kinds, kinds);
        return this;
    }
    since(since) {
        if (!since)
            return this;
        __classPrivateFieldGet(this, _RequestFilterBuilder_filter, "f").since = since;
        return this;
    }
    until(until) {
        if (!until)
            return this;
        __classPrivateFieldGet(this, _RequestFilterBuilder_filter, "f").until = until;
        return this;
    }
    limit(limit) {
        if (!limit)
            return this;
        __classPrivateFieldGet(this, _RequestFilterBuilder_filter, "f").limit = limit;
        return this;
    }
    tag(key, value) {
        if (!value)
            return this;
        __classPrivateFieldGet(this, _RequestFilterBuilder_filter, "f")[`#${key}`] = (0, shared_1.appendDedupe)(__classPrivateFieldGet(this, _RequestFilterBuilder_filter, "f")[`#${key}`], value);
        return this;
    }
    search(keyword) {
        if (!keyword)
            return this;
        __classPrivateFieldGet(this, _RequestFilterBuilder_filter, "f").search = keyword;
        return this;
    }
    /**
     * Build/expand this filter into a set of relay specific queries
     */
    build(relays, id) {
        // use the explicit relay list first
        if (__classPrivateFieldGet(this, _RequestFilterBuilder_relays, "f").size > 0) {
            return [...__classPrivateFieldGet(this, _RequestFilterBuilder_relays, "f")].map(r => {
                return {
                    filters: [__classPrivateFieldGet(this, _RequestFilterBuilder_filter, "f")],
                    relay: r,
                    strategy: RequestStrategy.ExplicitRelays,
                };
            });
        }
        // If any authors are set use the gossip model to fetch data for each author
        if (__classPrivateFieldGet(this, _RequestFilterBuilder_filter, "f").authors) {
            const split = (0, gossip_model_1.splitByWriteRelays)(relays, __classPrivateFieldGet(this, _RequestFilterBuilder_filter, "f"));
            return split.map(a => {
                return {
                    filters: [a.filter],
                    relay: a.relay,
                    strategy: RequestStrategy.AuthorsRelays,
                };
            });
        }
        return [
            {
                filters: [this.filter],
                relay: "",
                strategy: RequestStrategy.DefaultRelays,
            },
        ];
    }
}
exports.RequestFilterBuilder = RequestFilterBuilder;
_RequestFilterBuilder_filter = new WeakMap(), _RequestFilterBuilder_relays = new WeakMap();
//# sourceMappingURL=data:application/json;base64,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